import { render, staticRenderFns } from "./main-pileTab.vue?vue&type=template&id=268fb19a&scoped=true"
import script from "./main-pileTab.vue?vue&type=script&lang=js"
export * from "./main-pileTab.vue?vue&type=script&lang=js"
import style0 from "./main-pileTab.vue?vue&type=style&index=0&id=268fb19a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fb19a",
  null
  
)

export default component.exports